import { TipoOperazioneUnitaDocumentariaEnum } from "../enum/tipo-operazione-unita-documentaria-enum";
import { DifferenzaVO } from "./differenzaVO";
import { UtenteVO } from "./utenteVO";

export class AttivitaUnitaDocumentariaVO {
  idFascicolo: string;
  differenze: DifferenzaVO[];
  idUnitaDocumentaria: string;
  dataOperazione: string;
  operatore: UtenteVO;
  tipoOperazione: TipoOperazioneUnitaDocumentariaEnum;
}
